module.exports = __webpack_public_path__ + "media/images/doc-thumb-2-329dcfb7179820d03956b4580514fc5f.jpg";